import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=504e9760&"
import script from "./ViewOrder.vue?vue&type=script&lang=ts&"
export * from "./ViewOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ViewOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports